import React from 'react';
import { observer } from 'mobx-react-lite';
import { IMInputText, IMSelect } from '@insurancemenu/imenu-components-lib';
import { IMSicSearch } from '@insurancemenu/imenu-components-lib/dist/components/imForm/capabilities/sic/IMSicSearch';
import SectionTitle from 'components/common/general/SectionTitle';
import DomainProductLines from 'components/common/initiate-proposal/DomainProductLines';
import {
  IMFormStyled,
  FollowingSectionTitleStyled,
  IMZipCodeFieldStyled,
  IMZipCountyFieldStyled,
  IMZipStateFieldStyled,
} from 'components/common/initiate-proposal/styles';
import { useDDIAQuoteProposalInfoPageStore } from 'store/pages/quote/quote-proposal-info/ddia/pageStore';
import { DDIA_PROPOSAL_INFO_FORM_ID } from './constants';

const DDIAQuoteProposalInfoForm: React.FC = observer(() => {
  const {
    proposalFormDelegate: { proposalForm, effectiveDatesOptions },
    proposalInfoDelegate: { domainProductLineItems, isDomainProductLinesLoading },
    isStepCompleted,
  } = useDDIAQuoteProposalInfoPageStore();
  return (
    <IMFormStyled id={DDIA_PROPOSAL_INFO_FORM_ID} formController={proposalForm}>
      <SectionTitle title="Basic Information" />
      <IMInputText label="Proposal Name" name="proposalName" size="full" />
      <IMSelect label="Effective Date" name="effectiveDate" size="full" options={effectiveDatesOptions} disabled />
      <IMZipCodeFieldStyled size="s" disabled={isStepCompleted} />
      <IMZipStateFieldStyled size="s" disabled />
      <IMZipCountyFieldStyled size="s" disabled={isStepCompleted} />

      <FollowingSectionTitleStyled title="Additional Information" />
      <IMSicSearch label="SIC Code" size="full" disabled />

      <FollowingSectionTitleStyled title="Available Product Lines" />
      <DomainProductLines domainProductLineItems={domainProductLineItems} isLoading={isDomainProductLinesLoading} />
    </IMFormStyled>
  );
});

export default DDIAQuoteProposalInfoForm;
